export const IS_BROWSER_MAIN_THREAD =
  typeof window != 'undefined' &&
  typeof document != 'undefined'

export const IS_BROWSER_WORKER_THREAD =
    typeof self === "object" &&
    typeof WorkerGlobalScope != 'undefined'


export const IS_BROWSER = IS_BROWSER_MAIN_THREAD || IS_BROWSER_WORKER_THREAD;

export const IS_NODE =
  typeof process !== "undefined" &&
  process.versions != null &&
  process.versions.node != null;